export default __webpack_public_path__ + "static/media/Chauffeur livreur indépendant France Box2Home2.fdd8c5f2.svg";